module.exports = __webpack_public_path__ + "assets/img/1701_02.jpg?06fa131e7919abb97b8d999235eeaff1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1701_02.jpg
// module id = 1121
// module chunks = 0